<template>
  <div class="exchangeable-products-wrapper new-exchangeable-product-wrapper">
    <SessionContent></SessionContent>
    <div class="change-product change-product-padding position-relative pt-0 exchangeable-products mx-3 px-0">
      <div class="bg-white position-absolute ch-prod-bg"></div>
      <section class="boxes">
        <b-row class="justify-content-md-center">
          <b-col lg="10" class="pl-sm-3 pr-sm-3 pl-0 pr-0">
            <template v-if="selectedItem && originalProduct">
              <h6 class="exchangeable-heading mb-0 mb-md-3">Current Order</h6>
              <ExchangeProduct
                :product="originalProduct"
                :selected="isSelected(originalProduct.to_campaign_product, originalProduct.quantity, originalProduct.price)"
                :original="true"
                :item="selectedItem"
                @select="selectExchangeableProduct"
              ></ExchangeProduct>
              <div v-if="exchangeableProducts.length">
                <hr />
                <h6 class="exchangeable-heading mt-3">Other Package Options</h6>
                <div class="exchangeable-subheading">*Replace Current Order With Another Package below:</div>
                <ExchangeProduct
                  v-for="exchangeableProduct in exchangeableProducts"
                  :key="exchangeableProduct.id"
                  :product="exchangeableProduct"
                  :selected="isSelected(exchangeableProduct.to_campaign_product, exchangeableProduct.quantity, exchangeableProduct.price)"
                  :original="false"
                  :item="selectedItem"
                  @select="selectExchangeableProduct"
                ></ExchangeProduct>
              </div>
              <div v-else>
                <h6>Quantity</h6>
                <b-form-select id="quantity" :value="selectedQuantity" @input="updateQuantity($event)">
                  <option v-for="i in maxQuantity" :key="i" :value="i">{{i}}</option>
                </b-form-select>
              </div>
              <div class="order-totals bold mr-3 align-items-center d-flex justify-content-end">
                <div class="label price pr-1 pr-sm-3">Total: </div>
                <div class="notranslate price mr-0">{{totalPrice}}</div>
              </div>
            </template>
          </b-col>
        </b-row>
      </section>
    </div>
    <div>
      <b-row>
        <b-col class="my-class">
          <h4 class="refund-text">*We will issue a refund of the difference you paid.</h4>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center boxes claim">
        <b-col md="6" class="my-class">
          <b-row>
            <b-col v-for="input in session.valid_inputs" :key="'choice-' + input.id" md="12" class="text-center">
              <b-link v-if="isLink(input)"
                      @click="selectInput(input)"
                      class="q_links step-link"
                      :class="getCustomClass(input)"
                      v-html="input.formatted_label"
                      :disabled="needsProductSelection(input)"
              ></b-link>
              <b-button v-else block
                        @click="selectInput(input)"
                        class="btn btn-default btn-session faq_btn update-info"
                        :class="getCustomClass(input)"
                        variant="primary"
                        :disabled="needsProductSelection(input)"
              ><div v-html="input.formatted_label"></div></b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <section class="boxes update-back-btn step-back-button">
      <b-row class="justify-content-md-center">
        <b-col v-if="session && session.can_undo" md="4" lg="3" class="p-0">
          <b-button block @click="goBack()" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { InputType } from '../constants'
import { formatCurrency, getCampaignProductImageUrl, getClassFromObject } from '../utils'
import axios from 'axios'
const SessionContent = () => import('./SessionContent')
const ExchangeProduct = () => import('./ExchangeProduct')

export default {
  name: 'SelectExchangeProduct',
  components: {ExchangeProduct, SessionContent},
  props: {
    item: Object
  },
  data: function() {
    return {
      originalProduct: null,
      selectedExchangeableProduct: null,
      selectedItem: null,
      selectProductFields: {},
      maxQuantity: 10
    }
  },
  computed: {
    ...mapState(['session']),
    selectedProduct: function() {
      return this.selectedExchangeableProduct ? this.selectedExchangeableProduct.to_campaign_product : null
    },
    selectedQuantity: function() {
      return this.selectedExchangeableProduct ? this.selectedExchangeableProduct.quantity : 1
    },
    selectedPrice: function() {
      return Number(this.selectedExchangeableProduct ? this.selectedExchangeableProduct.price : '0')
    },
    exchangeableProducts: function() {
      return this.selectedItem.campaign_product.exchangeable_products.filter(
        exchangeableProduct =>
          (exchangeableProduct.to_campaign_product.id !== this.selectedItem.campaign_product.id) ||
          (exchangeableProduct.quantity !== this.selectedItem.quantity) ||
          (Number(exchangeableProduct.price) !== Number(this.selectedItem.price))
      )
    },
    totalPrice: function() {
      if (this.isSelected(this.selectedItem.campaign_product, this.selectedItem.quantity, this.selectedItem.price)) {
        return formatCurrency(this.selectedItem.current_price, this.selectedItem.order.currency)
      }

      const unitPrice = this.selectedExchangeableProduct ? this.selectedExchangeableProduct.price : 0
      return formatCurrency(unitPrice * this.selectedQuantity, this.selectedItem.order.currency)
    }
  },
  methods: {
    isLink: function(input) {
      return input.type === InputType.Link
    },
    getCustomClass: function(input) {
      return getClassFromObject(input)
    },
    selectExchangeableProduct(exchangeableProduct) {
      this.selectedExchangeableProduct = exchangeableProduct
    },
    updateQuantity: function(val) {
      const quantity = parseInt(val)

      if (quantity > 0 && (quantity !== this.selectedQuantity)) { // if quantity changed
        this.selectedExchangeableProduct.quantity = quantity
      }
    },
    showQuantity: function(exchangeableProduct) {
      return !exchangeableProduct.display_name
    },
    getDisplayName: function(exchangeableProduct) {
      return exchangeableProduct.display_name
        ? exchangeableProduct.display_name : exchangeableProduct.to_campaign_product.name
    },
    getImageUrl: function(campaignProduct) {
      return getCampaignProductImageUrl(campaignProduct, 'small')
    },
    isSelected: function(campaignProduct, quantity, price) {
      return this.selectedProduct &&
        (this.selectedProduct.id === campaignProduct.id) &&
        (this.selectedQuantity === quantity) &&
        (!Number.isNaN(Number(price)) && this.selectedPrice === Number(price))
    },
    needsProductSelection: function(input) {
      if (input.id in this.selectProductFields) {
        if (this.selectedProduct) {
          return this.isSelected(this.selectedItem.campaign_product, this.selectedItem.quantity,
            this.selectedItem.price)
        }

        return true
      }

      return false
    },
    selectInput(input) {
      if (!this.needsProductSelection(input)) {
        let inputData = null // no data required for input
        let selectedProduct = null

        if (this.selectedProduct && (input.id in this.selectProductFields)) {
          inputData = {}
          selectedProduct = this.selectedProduct

          // build the data required for the input
          inputData[this.selectProductFields[input.id]] = this.selectedProduct.id

          if (this.selectedQuantity) {
            inputData['quantity'] = this.selectedQuantity
          }
        }

        this.$emit('select', input, inputData, selectedProduct)
      }
    },
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore changes to item selection)
    }
  },
  created() {
    this.$store.commit('busy')
    this.selectedItem = this.item || this.session.selected_item

    axios.all([
      axios.get('/campaign_products/' + this.selectedItem.campaign_product.id.toString() + '/'),
      axios.get('/campaign_products/' + this.selectedItem.campaign_product.id.toString() + '/exchangeables/')
    ]).then(result => {
      this.selectedItem.campaign_product = result[0].data
      this.selectedItem.campaign_product.exchangeable_products = result[1].data
      this.originalProduct = {
        to_campaign_product: this.selectedItem.campaign_product,
        quantity: this.selectedItem.quantity,
        price: this.selectedItem.unit_price,
        display_name: null,
        sales_phrase: this.selectedItem.product.sales_phrase,
        subtext: this.selectedItem.subtext,
        retail_price: this.selectedItem.retail_price
      }

      // our product might already be defined in the exchangeable products - so get the data from there
      this.selectedItem.campaign_product.exchangeable_products.some(
        exchangeableProduct => {
          if ((exchangeableProduct.to_campaign_product.id === this.selectedItem.campaign_product.id) &&
            (exchangeableProduct.quantity === this.selectedItem.quantity)) {
            this.originalProduct = exchangeableProduct
            return true
          }

          return false
        }
      )

      // get the required product selection fields
      for (const input of this.session.valid_inputs) {
        const keys = Object.keys(input.input_fields)

        if (keys && keys.length) {
          const key = keys[0]

          if (input.input_fields[key].type === InputType.Product) {
            this.selectProductFields[input.id] = key // field name for product selection
          }
        }
      }

      this.selectedExchangeableProduct = this.originalProduct
      if ('campaign_product' in this.selectedItem && 'max_quantity' in this.selectedItem.campaign_product) {
        this.maxQuantity = this.selectedItem.campaign_product.max_quantity
      }

      this.$store.commit('ready')
    }, error => {
      console.error(error)
      this.$store.commit('critical_error', error)
      this.$store.commit('ready')
    })
  }
}
</script>

<style scoped>

</style>
